import { Component, OnInit, Input, ContentChild, ElementRef, AfterContentInit } from '@angular/core';
import { BackKeyUrlService } from './back-key-url.service';

@Component({
  selector: 'navaar-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements AfterContentInit {
  @Input() public color: string;
  @Input('z-index') public zIndex: number = 1000;

  @Input('title') public title: string;
  @Input('back-url') public backUrl: string[] | null = null;
  @Input('show-custom-content') public isShowCustomContent: boolean = false;
  @Input('show-back-icon') public showBackIcon: boolean = true;
  @ContentChild('wrapper', { static: true }) wrapper: ElementRef<any>;

  public hasContent = false;

  public ngAfterContentInit() {
    this.hasContent = this.wrapper && this.wrapper.nativeElement.childNodes.length > 0;
  }

  constructor(private readonly backKeyUrlService: BackKeyUrlService) { }

  public goBack() {
    this.backKeyUrlService.goBack(this.backUrl);
  }
}
